import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  errorMessage: {
    position: "absolute",
    color: "#BF3333",
  },
});

function FieldErrorMessage({ message }) {
  const classes = useStyles();
  return (
    <p data-test="error-message" className={classes.errorMessage}>
      {message}
    </p>
  );
}

FieldErrorMessage.propTypes = {
  message: PropTypes.node.isRequired,
};

export default FieldErrorMessage;
